/* Simple Pimple theme: variant and subscription picker, quantity steppers. */
(function () {
  function money(v) { return v || ''; }

  document.querySelectorAll('[data-product]').forEach(function (root) {
    var jsonEl = root.querySelector('[data-product-json]');
    if (!jsonEl) return;
    var data = JSON.parse(jsonEl.textContent);
    var idInput = root.querySelector('[data-variant-id]');
    var planInput = root.querySelector('[data-selling-plan]');
    var priceEl = root.querySelector('[data-price]');
    var compareEl = root.querySelector('[data-compare]');
    var button = root.querySelector('[data-add]');
    var label = root.querySelector('[data-add-label]');
    var sticky = root.querySelector('[data-sticky]');
    var stickyPrice = root.querySelector('[data-sticky-price]');
    var stickyAdd = root.querySelector('[data-sticky-add]');

    function find(id) {
      for (var i = 0; i < data.variants.length; i++) {
        if (String(data.variants[i].id) === String(id)) return data.variants[i];
      }
      return null;
    }

    function priceFor(v, plan) { return plan && v.plans[plan] ? v.plans[plan] : v.price; }

    function update() {
      var v = find(idInput.value);
      if (!v) return;
      var plan = planInput && !planInput.disabled ? planInput.value : '';
      var price = priceFor(v, plan);
      if (priceEl) priceEl.textContent = money(price);
      if (compareEl) {
        var cmp = plan && v.plans[plan] ? v.price : v.compare;
        compareEl.textContent = cmp && cmp !== price ? cmp : '';
      }
      if (button) {
        button.disabled = !v.available;
        if (label) label.textContent = v.available ? button.getAttribute('data-label-add') : button.getAttribute('data-label-sold');
      }
      if (stickyPrice) stickyPrice.textContent = money(price);
      if (stickyAdd) {
        stickyAdd.disabled = !v.available;
        stickyAdd.textContent = v.available ? button.getAttribute('data-label-add') : button.getAttribute('data-label-sold');
      }
      var bar = root.querySelector('[data-shipbar]');
      if (bar) {
        var qtyEl = root.querySelector('input[name="quantity"]'), q = Math.max(1, parseInt(qtyEl && qtyEl.value, 10) || 1);
        var th = +bar.getAttribute('data-threshold'), total = v.cents * q, left = th - total, fmt = bar.getAttribute('data-money-format') || '${{amount}}';
        var cash = function (c) { return fmt.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, (c / 100).toFixed(2)); };
        bar.querySelector('[data-ship-text]').textContent = left > 0 ? 'You\u2019re ' + cash(left) + ' away from free shipping.' : 'Free shipping unlocked.';
        bar.querySelector('[data-ship-fill]').style.width = Math.max(4, Math.min(100, total / th * 100)) + '%';
      }
      root.querySelectorAll('[data-opt-price]').forEach(function (el) {
        var ov = find(el.getAttribute('data-opt-price'));
        if (ov) el.textContent = priceFor(ov, plan);
      });
    }

    root.querySelectorAll('[data-variant-pick]').forEach(function (r) {
      r.addEventListener('change', function () {
        idInput.value = this.value;
        update();
        if (root.hasAttribute('data-update-url') && window.history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', this.value);
          window.history.replaceState(null, '', url.toString());
        }
      });
    });

    root.querySelectorAll('[data-plan-pick]').forEach(function (r) {
      r.addEventListener('change', function () {
        if (planInput) { planInput.value = this.value; planInput.disabled = !this.value; }
        update();
      });
    });

    var qtyInput = root.querySelector('input[name="quantity"]');
    if (qtyInput) qtyInput.addEventListener('change', update);
    update();

    // Sticky bar: show it once the main button has scrolled up out of view.
    if (sticky && button && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        var show = !e.isIntersecting && e.boundingClientRect.top < 0;
        sticky.hidden = !show;
        document.body.classList.toggle('has-sticky', show);
      }).observe(button);
    }
  });

  // Cart upgrade: add the bigger pack first, then remove the old line, so a failure never empties the cart.
  document.querySelectorAll('[data-upgrade]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      btn.disabled = true;
      btn.textContent = 'Switching\u2026';
      var item = { id: Number(btn.getAttribute('data-variant')), quantity: 1 };
      var plan = btn.getAttribute('data-plan');
      if (plan) item.selling_plan = Number(plan);
      var headers = { 'Content-Type': 'application/json', 'Accept': 'application/json' };
      fetch(btn.getAttribute('data-add-url') + '.js', { method: 'POST', headers: headers, body: JSON.stringify({ items: [item] }) })
        .then(function (r) {
          if (!r.ok) throw new Error('add failed');
          return fetch(btn.getAttribute('data-change-url') + '.js', { method: 'POST', headers: headers, body: JSON.stringify({ id: btn.getAttribute('data-line-key'), quantity: 0 }) });
        })
        .then(function () { window.location.reload(); })
        .catch(function () { window.location.reload(); });
    });
  });

  document.querySelectorAll('[data-qty]').forEach(function (wrap) {
    var input = wrap.querySelector('input');
    wrap.querySelectorAll('[data-step]').forEach(function (b) {
      b.addEventListener('click', function () {
        var min = parseInt(input.min || '0', 10);
        var next = Math.max(min, (parseInt(input.value, 10) || 0) + parseInt(this.getAttribute('data-step'), 10));
        input.value = next;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });

  document.querySelectorAll('[data-autosubmit]').forEach(function (form) {
    var t;
    form.addEventListener('change', function (e) {
      if (!e.target.matches('input[name="updates[]"]')) return;
      clearTimeout(t);
      t = setTimeout(function () { form.submit(); }, 450);
    });
  });
})();
